<template>
  <div :class="`seat-selection--modal-container ${(this.showModal ? 'is--visible' : '')} ${locale}`" v-if="flight">
    <div class="seat-selection--modal" :style="{'--fontFamily': style.fontFamily}">

      <div class="seat-selection--modal-title" :style="{'--bgColor3': style.bgColor3, '--passengerSelectedColor': style.passengerSelectedColor}">
        <i v-if="modalType === 'warning'" class="fas fa-exclamation-triangle ss-modal-warning"></i>
        <i v-else class="fas fa-check-circle ss-modal-success"></i>
      </div>
      <div class='seat-selection--modal-body'>
        <p v-html="modalText"></p>
      </div>
      <div class="seat-selection--modal-footer" :style="{'--bgColor3': style.bgColor3, '--passengerSelectedColor': style.passengerSelectedColor, '--passengerSelectedFontColor': style.passengerSelectedFontColor}">
        <button @click="hideModal" class="">{{text.confirm_children_near_adult}}</button>
      </div>
    </div>

  </div>
</template>
<script>
import {mapGetters, mapState, mapActions} from 'vuex'

export default {
  computed: {
    ...mapGetters(['style', 'flight', 'text', 'locale']),
    ...mapState(['isModalVisible', 'modalText', 'modalType', 'loading']),
    showModal () {
      return !this.loading && this.isModalVisible
    }
  },
  methods: {
    ...mapActions(['hideModal'])
  }
}
</script>
<style>
  #ss-container .seat-selection--modal-footer {
    text-align: center;
    padding: 15px
  }
  #ss-container .seat-selection--modal-footer button {
    cursor: pointer;
    background-color: var(--passengerSelectedColor);
    border-radius: 2px;
    color: var(--passengerSelectedFontColor);
    -webkit-box-shadow: none;
    box-shadow: none;
    border: 0;
    height: 40px;
    font-size: 16px;
    width: 165px;
  }
  #ss-container .seat-selection--modal-title {
    height: 50px;
    background-color: #fef4e4;
    display: flex;
    font-size: 26px;
  }
  .he .seat-selection--modal-body {
    text-align: right !important;
  }
  #ss-container .seat-selection--modal-title i {
    margin: auto;
    text-align: center;
  }
  #ss-container .seat-selection--modal-title i.ss-modal-warning {
    color: #fba407;
  }
  #ss-container .seat-selection--modal-title i.ss-modal-success {
    color: #82c91e;
  }
  #ss-container .seat-selection--modal-body {
    padding: 15px;
  }
  #ss-container .seat-selection--modal {
    font-family: var(--fontFamily);
    background-color: #fff;
    border-radius: .125rem;
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    width: 300px;
    z-index: 2;
  }
  #ss-container .seat-selection--modal-container.is--visible {
    visibility: visible;
  }

  #ss-container .seat-selection--modal-container {
    background-color: rgba(0, 0, 0, .75);
    -webkit-box-align: center;
    align-items: center;
    bottom: 0;
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    -webkit-box-pack: center;
    justify-content: center;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 99999;
    visibility: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue